import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 1rem;
  }

  .downtimes-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .downtimes-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .downtimes-header h3 {
    margin: 0;
    color: var(--sl-color-neutral-800);
    font-size: 1.1rem;
    font-weight: 600;
  }

  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 2rem;
    color: var(--sl-color-neutral-600);
  }

  .error-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 2rem;
    color: var(--sl-color-danger-600);
  }

  .error-icon {
    font-size: 1.5rem;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    text-align: center;
    color: var(--sl-color-neutral-600);
  }

  .empty-icon {
    font-size: 3rem;
    color: var(--sl-color-neutral-400);
    margin-bottom: 1rem;
  }

  .empty-state h3 {
    margin: 0 0 0.5rem 0;
    color: var(--sl-color-neutral-700);
    font-size: 1.2rem;
  }

  .empty-state p {
    margin: 0;
    font-size: 0.9rem;
  }

  .data-table {
    background: var(--sl-color-neutral-0);
    border-radius: var(--sl-border-radius-medium);
    overflow: hidden;
    box-shadow: var(--sl-shadow-small);
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
  }

  thead {
    background: var(--sl-color-neutral-100);
  }

  th {
    padding: 0.75rem 1rem;
    text-align: left;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.025em;
  }

  td {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-700);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .clickable-row {
    cursor: pointer;
    transition: background-color 0.15s ease;
  }

  .clickable-row:hover {
    background: var(--sl-color-neutral-50);
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
    border-radius: var(--sl-border-radius-small);
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
  }

  .status-badge.active {
    background: var(--sl-color-warning-100);
    color: var(--sl-color-warning-800);
  }

  .status-badge.completed {
    background: var(--sl-color-success-100);
    color: var(--sl-color-success-800);
  }

  /* Responsive design */
  @media (max-width: 768px) {
    :host {
      padding: 0.5rem;
    }

    .data-table {
      overflow-x: auto;
    }

    table {
      min-width: 600px;
    }

    th, td {
      padding: 0.5rem;
      font-size: 0.8rem;
    }
  }
`;
